import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
} from "@mui/material";
import DesktopEventPageMapButton from "../DesktopEventPageMapButton";
import { useNavigate } from "react-router-dom";
import FilterCountry from "./FilterCountry";
import FilterPhotographer from "./FilterPhotographer";
import FilterActivity from "./FilterActivity";
import FilterGalleryEvent from "./FilterGalleryEvent";
import FilterDate from "./FilterDate";
import { useEventPageContext } from "./EventPageContext";
import { useGalleryFilterSearchParams } from "./useGalleryFilterSearchParams";
import { makeLogger } from "../../utils/logger";

const logger = makeLogger({
  enabled: true,
  label: "DesktopEventPageFilter",
  color: "pink",
});

export default function DesktopEventPageFilter({ gallery_event_name }) {
  useSelector(() => ({})); // force redux state reconcile
  const eventPageCtx = useEventPageContext();
  const navigate = useNavigate();
  // const [galleryFilterSearchParams] = useGalleryFilterSearchParams();
  // const isUserSearch = galleryFilterSearchParams.any !== null;

  const handleClearFiltersClick = () => {
    logger.log("Reset all filter");
    eventPageCtx.updateListFilter({
      gallery_type: "event",
      gallery_event: null,
      any_field: null,
      activity_tags: null,
      country: null,
      shot_at_date_from: null,
      shot_at_date_to: null,
      photographers: null,
      _callSource: "DesktopEventPageFilter",
    });
    navigate(`/customer/events/`);
  }

  return (
    <>
      <DesktopEventPageMapButton />
        
      <h4>Filter by:</h4>
      {/*<FilterCountry />*/}
      <FilterGalleryEvent />
      <FilterDate />
      <FilterActivity />
      <FilterPhotographer />
      {eventPageCtx.hasActiveFilters && <Button size="small" onClick={handleClearFiltersClick}>clear filters</Button>}
    </>
  );
}
